import { formatUSD, formatNum, rateLabel } from "@/lib/format";

const projectCoins = (p) => p.items.reduce((s, i) => s + (i.coins || 0), 0);

function buildHtml(d) {
  const today = new Date().toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  const projectRows = d.projects
    .map((p) => {
      const coins = projectCoins(p);
      const tasks = p.items
        .map(
          (it) =>
            `<tr class="task"><td>&nbsp;&nbsp;• ${it.name}</td><td>${formatNum(it.coins)}</td><td>${formatUSD(it.coins * d.blendedRate)}</td></tr>`,
        )
        .join("");
      return `<tr class="proj"><td><b>${p.name}</b></td><td><b>${formatNum(coins)}</b></td><td><b>${formatUSD(coins * d.blendedRate)}</b></td></tr>${tasks}`;
    })
    .join("");

  return `<html><head><meta charset="utf-8"/><title>CreditCost Estimate</title>
  <style>
    body { font-family: -apple-system, Helvetica, Arial, sans-serif; color:#1C1C1E; padding:32px; }
    h1 { color:#4A7A59; margin-bottom:4px; }
    .sub { color:#8E8E93; margin-top:0; }
    .grand { background:#E6EFE9; border-radius:12px; padding:20px; margin:24px 0; }
    .grand .amt { font-size:34px; font-weight:700; color:#2D4A36; }
    table { width:100%; border-collapse:collapse; margin-top:8px; }
    th { text-align:left; color:#8E8E93; font-size:12px; text-transform:uppercase; border-bottom:2px solid #E5E5EA; padding:8px 4px; }
    td { padding:8px 4px; border-bottom:1px solid #F0F0F0; font-size:14px; }
    tr.proj td { border-top:1px solid #E5E5EA; }
    tr.task td { color:#555; font-size:13px; border-bottom:none; }
    th:nth-child(2), td:nth-child(2), th:nth-child(3), td:nth-child(3) { text-align:right; }
    .foot { margin-top:40px; color:#8E8E93; font-size:12px; text-align:center; }
  </style></head><body>
    <h1>CreditCost Estimate</h1>
    <p class="sub">${today}</p>
    <div class="grand">
      <div>TOTAL PROJECT COST</div>
      <div class="amt">${formatUSD(d.totalProjectCost)}</div>
      <div class="sub">${formatNum(d.totalCoinsUsed)} coins &middot; ${rateLabel(d.blendedRate)} blended</div>
    </div>
    <table>
      <thead><tr><th>Project / Task</th><th>Coins</th><th>Cost</th></tr></thead>
      <tbody>${projectRows || '<tr><td colspan="3">No projects yet.</td></tr>'}</tbody>
    </table>
    <div class="foot">Credits purchased: ${formatNum(d.coinsPurchased)} &middot; Spent: ${formatUSD(d.totalSpent)} &middot; Remaining: ${formatNum(d.coinsRemaining)}</div>
  </body></html>`;
}

function buildCsv(d) {
  const esc = (s) => `"${String(s).replace(/"/g, '""')}"`;
  const rows = [["Project", "Task", "Coins", "Cost (USD)"].join(",")];
  d.projects.forEach((p) => {
    if (p.items.length === 0) rows.push([esc(p.name), esc("(no tasks)"), "0", "0.00"].join(","));
    p.items.forEach((it) =>
      rows.push([esc(p.name), esc(it.name), String(it.coins), (it.coins * d.blendedRate).toFixed(2)].join(",")),
    );
  });
  rows.push("");
  rows.push([esc("TOTAL"), "", String(d.totalCoinsUsed), d.totalProjectCost.toFixed(2)].join(","));
  rows.push([esc("Blended rate ($/coin)"), "", "", d.blendedRate.toFixed(4)].join(","));
  rows.push([esc("Credits purchased"), "", String(d.coinsPurchased), d.totalSpent.toFixed(2)].join(","));
  return rows.join("\n");
}

export function exportPdf(d) {
  const w = window.open("", "_blank");
  if (!w) throw new Error("popup blocked");
  w.document.write(buildHtml(d));
  w.document.close();
  w.focus();
  setTimeout(() => w.print(), 350);
}

export function exportCsv(d) {
  const blob = new Blob([buildCsv(d)], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "creditcost-estimate.csv";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
